import * as React from "react";
import BasePoliciesLoadedRoute from "../../features/policies/routes/policies-loaded";
import useAppSelector from "../../hooks/useAppSelector";
export default function HomePoliciesLoadedRoute() {
    var homePolicy = useAppSelector(function (state) { var _a; return (_a = state.policies.home) === null || _a === void 0 ? void 0 : _a[0]; });
    return React.createElement(BasePoliciesLoadedRoute, { policy: homePolicy });
}
